export class PKBillReaderResultErrorMessage {
	public static InternalError = 0;
	public static MissingError = 1;
	public static StatusError = 2;
	public static LocationError = 3;

	public static formatVerificationErrorMessage(errorIndex: number, sessionName: string, customerName: string): string {
		switch (errorIndex) {
			case PKBillReaderResultErrorMessage.MissingError:
				return `No bill reader results found for ${sessionName} - ${customerName}`;
			case PKBillReaderResultErrorMessage.StatusError:
				return `Cannot verify ${sessionName} - ${customerName} because one or more bills have an error status`;
			case PKBillReaderResultErrorMessage.LocationError:
				return `No matching location for ${sessionName} - ${customerName}, please correct the customerName/accountNumber/address`;
			default:
				return `Cannot verify ${sessionName} - ${customerName}`;
		}
	}
}

export class PKBillReaderResultLocations {
	public static Unverified = 0;
	public static Verified = 1;
	public static PartialVerified = 2;

	public id: number;
	public sessionId?: string;
	public fileKey?: string;
	public billId?: string;
	public contractLocationId: string;
	public accountNumber: string;
	public address1: string;
	public contractLocationDisplay?: string;

	constructor(data?: PKBillReaderResultLocations) {
		Object.assign(this, data);
	}

	public static getSessionVerificationStatus(rows: { isVerified?: boolean }[]): number {
		const verifiedCount = rows.filter(r => r.isVerified).length;
		if (verifiedCount === rows.length) {
			return PKBillReaderResultLocations.Verified;
		}
		if (verifiedCount === 0) {
			return PKBillReaderResultLocations.Unverified;
		}

		return PKBillReaderResultLocations.PartialVerified;
	}
}

export class PKBillReaderResults {
	public id: number;
	public sessionId: string;
	public billId?: string;
	public customerName: string;
	public billReaderResultStatusId: number;
	public isVerified: boolean;
	public fileKey: string;
	public agentId?: string;
	public agentName?: string;
	public billReaderResultLocations: PKBillReaderResultLocations[];

	constructor(data?: PKBillReaderResults) {
		Object.assign(this, data);
		if (data?.billReaderResultLocations) {
			this.billReaderResultLocations = data.billReaderResultLocations.map(l => new PKBillReaderResultLocations(l));
		}
	}
}
